import { error, info, success, warning } from 'react-notification-system-redux';
import _ from 'lodash';

import store from '../store';
import errorHandler from './api/error';

export const showNotification = (type, options) => {
  switch (type) {
    case 'error':
      return store.dispatch(error(options));
    case 'info':
      return store.dispatch(info(options));
    case 'success':
      return store.dispatch(success(options));
    case 'warning':
      return store.dispatch(warning(options));
    default:
      throw new Error('invalid notification type');
  }
};

const notify = (options) => {
  let parsedOptions = {};

  // If an error was passed, format the notification options
  if (_.isError(options)) {
    parsedOptions.type = 'error';
    parsedOptions.title = errorHandler.convertToUserFriendlyErrorMessage(options.message);
    parsedOptions.messages = _.clone(options.messages);
  } else if (_.isString(options)) {
    // If a string was passed, assume it's JSON and parse it
    try {
      parsedOptions = JSON.parse(options);
    } catch (e) {
      console.warn(e); // eslint-disable-line no-console
    }
  } else {
    // Otherwise, copy the options directly
    parsedOptions = _.cloneDeep(options);
  }

  if (!_.has(parsedOptions, 'type')) throw new Error('no notification type provided');
  if (!_.has(parsedOptions, 'title')) throw new Error('no notification title provided');
  if (!_.isString(parsedOptions.title)) throw new Error('invalid notification title');

  let notifications = [];

  // title only, no messages
  if (_.isEmpty(parsedOptions.messages)) {
    notifications.push({
      title: parsedOptions.title,
      position: _.get(parsedOptions, 'position', 'br'),
      autoDismiss: _.get(parsedOptions, 'autoDismiss', 1),
      action: _.get(parsedOptions, 'action'),
    });
    // title and messages
  } else {
    notifications = _.map(parsedOptions.messages, message => ({
      title: parsedOptions.title,
      message,
      position: _.get(parsedOptions, 'position', 'br'),
      autoDismiss: _.get(parsedOptions, 'autoDismiss', 1),
      action: _.get(parsedOptions, 'action'),
    }));
  }

  return _.each(notifications, notification => showNotification(parsedOptions.type, notification));
};

export default notify;
